import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/input.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { CategorySegment } from 'components/categorySegment'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import GetSheetDone from 'get-sheet-done'
import Scrollchor from 'react-scrollchor'
// import * as d3fetch from 'd3-fetch'

// import './types.d'

const ARTICLE_ID = '30510165'
const SHEET_ID = '11bvNzi1rD0snNAKL7oVoafBfCU8VTSUW5cTIRCMO0EQ'

export function AppComponent() {
  const DATEOPTIONS = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }
  const [isLoading, setIsLoading] = useState(true)
  const [questionsCount, setQuestionsCount] = useState(0)
  const [questionsGroup, setQuestionsGroup] = useState<QuestionGroupArray>([])
  const [questions, setQuestions] = useState([])
  const [filteredQuestions, setFilteredQuestions] = useState([])
  const [lastUpdate, setLastUpdate] = useState(new Date())
  const [selectedQuestion, setSelectedQuestion] = useState('')
  const [intervalId, setIntervalId] = useState()
  const [texts, setTexts] = useState({
    title: '',
    intro: '',
    credits: {
      texts: '',
      project: ''
    }
  })

  useEffect(() => {
    // In case the spreadsheet goes down
    /* d3fetch.dsv(",", "https://www.24heures.ch/extern/interactive_wch/2020/2020-03-covid19-questions-reponses/data-1.csv", function(d) {
      return d
    }).then(function(data) {
      console.log(data)
    }) */

    let id = null

    // Get the title, intro, update and credits
    GetSheetDone.labeledCols(SHEET_ID, 5).then((sheet: sheetProps) => {
      const data = sheet.data[0]

      setLastUpdate(new Date(data['màj']))

      setTexts({
        title: data.titre,
        intro: data.chapeau,
        credits: {
          texts: data.textes,
          project: data.projet
        }
      })
    })

    // Get the categories
    GetSheetDone.labeledCols(SHEET_ID, 3).then((sheet: sheetProps) => {
      const categories = sheet.data

      // Get the questions/answers data
      GetSheetDone.labeledCols(SHEET_ID, 1).then((sheet: sheetProps) => {
        if (sheet.data) {
          const cats = {}
          const allQuestions = []

          sheet.data.map((d, i) => {
            // Test whether this category exists or not
            if (!Object.keys(cats).find(c => c === d.category)) {
              // console.log(categories)
              // console.log(d)
              // console.log(categories.find(c => c.id === d.category))

              cats[d.category] = {
                title: categories.find(c => c.id === d.category).title,
                description: categories.find(c => c.id === d.category)
                  .description,
                questions: []
              }
            }

            const questionData = {
              id: d.id,
              question: d.questionfr,
              answer: d.answerfr,
              category: d.category,
              sources: d.sourcesfr,
              new: d.new,
              number: null
            }

            // Push the question to the right category array
            cats[d.category].questions.push(questionData)

            // Push the question the uncategorized questions list
            allQuestions.push(questionData)
          })

          let iq = 1
          for (const c in cats) {
            for (const q in cats[c].questions) {
              cats[c].questions[q].number = iq
              iq++
            }
          }

          console.log(sheet.data)
          setQuestionsCount(sheet.data.length)
          setQuestions(allQuestions)
          setQuestionsGroup(cats)
          setIsLoading(false)
          const cat =
            cats[1 + Math.floor(Math.random() * Object.keys(cats).length)]
          setSelectedQuestion(
            cat.questions[Math.floor(Math.random() * cat.questions.length)]
              .question
          )

          id = setInterval(() => {
            const cat =
              cats[1 + Math.floor(Math.random() * Object.keys(cats).length)]
            setSelectedQuestion(
              cat.questions[Math.floor(Math.random() * cat.questions.length)]
                .question
            )
          }, 3000)
          setIntervalId(id)
        }
      })
    })

    return () => clearInterval(id)
  }, [])

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical very relaxed yellow segment'>
        <div className='header-question-container'>
          <div className='header-question'>{selectedQuestion}</div>
        </div>
        <img
          className='cover-virus virus-1'
          src={require('./cover-virus-transparent-1.png')}
        />
        <img
          className='cover-virus virus-2'
          src={require('./cover-virus-transparent-2.png')}
        />
        <img
          className='cover-virus virus-3'
          src={require('./cover-virus-transparent-2.png')}
        />
        <img
          className='cover-virus virus-4'
          src={require('./cover-virus-transparent-2.png')}
        />
        <img
          className='cover-virus virus-5'
          src={require('./cover-virus-transparent-1.png')}
        />
      </header>

      <div className='ui container title-header'>
        <h1 className='ui center aligned header'>
          <div className='content'>
            <div className='title-counter ui raised segment'>
              {questionsCount}
            </div>
            <div
              className='main-title'
              dangerouslySetInnerHTML={{ __html: texts.title }}
            />
            {/* <div className='sub header'>Sous-titre {questionsCount} questions</div> */}
          </div>
        </h1>
      </div>

      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <p
            className='title-intro'
            dangerouslySetInnerHTML={{ __html: texts.intro }}
          />
          <div className='last-update'>
            Dernière mise à jour le{' '}
            <b>{lastUpdate.toLocaleDateString('fr-FR', DATEOPTIONS)}</b>
          </div>
        </div>

        <div className='ui text container search-container'>
          <div className='ui raised segments question-group'>
            <div className='ui segment'>
              <div className='title-search'>
                Cherchez un mot clé ou continuez la lecture
              </div>
              <div className='ui big icon input'>
                <input
                  onChange={e => {
                    let result = []
                    const userValue = e.target.value
                      .toLowerCase()
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')

                    if (userValue.length > 2) {
                      result = questions.filter(question => {
                        return (
                          question.question
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .indexOf(userValue) !== -1 ||
                          question.answer
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .indexOf(userValue) !== -1
                        )
                      })
                    }

                    setFilteredQuestions(result)
                  }}
                  type='text'
                  placeholder='incubation'
                />
                <i className='search icon' />
              </div>
              <div className='search-message'>
                {filteredQuestions.length > 0
                  ? filteredQuestions.length + ' réponses'
                  : 'Pas de résultat'}
              </div>
            </div>
            <div className='question-group'>
              {filteredQuestions.map((q, i) => (
                <TypescriptComponent
                  articleId={ARTICLE_ID}
                  key={'question-group-' + i}
                  content={q}
                  open={false}
                />
              ))}
            </div>
          </div>
        </div>

        {isLoading ? (
          <div className='ui text container' style={{ marginTop: '4em' }}>
            <div className='ui placeholder'>
              <div className='image header'>
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='medium line' />
                <div className='short line' />
              </div>
            </div>
            <div className='ui placeholder'>
              <div className='image header'>
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='medium line' />
                <div className='short line' />
              </div>
            </div>
            <div className='ui placeholder'>
              <div className='image header'>
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='medium line' />
                <div className='short line' />
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className='ui text container'>
              <div className='categories-list'>
                <div className='ui very relaxed divided list raised segment'>
                  {Object.keys(questionsGroup).map(
                    (c: QuestionGroup, i: number) => (
                      <div className='item' key={'category-menu-' + i}>
                        <Scrollchor to={'category-' + i} disableHistory>
                          {/* <img className="ui avatar image" src={require("./virus.png")} /> */}
                          <div className='content'>
                            {questionsGroup[c].title}
                            <div
                              className='description'
                              dangerouslySetInnerHTML={{
                                __html: questionsGroup[c].description
                              }}
                            />
                          </div>
                          <i className='right' />
                        </Scrollchor>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
            {Object.keys(questionsGroup).map((c: QuestionGroup, i: number) => (
              <div
                className='category-group'
                id={'category-' + i}
                key={'category-title' + i}
              >
                <CategorySegment title={questionsGroup[c].title} />
                <div className='ui text container'>
                  <div className='ui raised segments question-group'>
                    {questionsGroup[c].questions.map(
                      (q: QuestionGroup, i: number) => (
                        <TypescriptComponent
                          articleId={ARTICLE_ID}
                          key={'question-group-' + i}
                          content={q}
                          open={false}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        mailTo='atm@tamedia.ch'
        hidePortfolioTeaser
        locale='fr'
        articleId={ARTICLE_ID}
        credits={[
          ['Textes', texts.credits.texts],
          ['Conception', 'Mathieu Rudaz'],
          ['Gestion de projet', texts.credits.project]
        ]}
        questions={[
          'Ce contenu était-il informatif?',
          'La mise en oeuvre a-t-elle fonctionné?',
          'La mise en forme vous plaît-elle?'
        ]}
      />
    </div>
  )
}
